export default __webpack_public_path__ + "static/media/g2022-1.c881d9d7.jpeg";